import { useEffect, useState } from "react";
import DrawerLateral from "./DrawerLateral";
import Button from "../../../componentes/button/button";
import Textarea from "../../../componentes/input/textarea";
import { CustomDropdown } from "../../../componentes/dropdown/CustomDropdown";
import SolicitacaoAdminService from "../../../services/resource/solicitacaoAdminService";
import UsuarioService from "../../../services/resource/usuarioService";
import { etapaLabel } from "../../../utils/solicitacoes/processoRegistry";
import { humanizarEtapa } from "../../../utils/solicitacoes/statusConfig";

const service = new SolicitacaoAdminService();
const usuarioService = new UsuarioService();

// Sidebar administrativo: reatribui só a tarefa atual (nunca o solicitante nem o histórico) a um
// outro membro do grupo que rege a etapa — mesmo padrão visual de EncaminhamentoSidebar.jsx.
export default function AlterarResponsavelSidebar({ isOpen, solicitacao, onFechar, onConfirmar }) {
    const [usuarios, setUsuarios] = useState([]);
    const [carregandoUsuarios, setCarregandoUsuarios] = useState(false);
    const [novoUsuarioId, setNovoUsuarioId] = useState(null);
    const [motivo, setMotivo] = useState("");
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        if (!isOpen || !solicitacao) return;
        setNovoUsuarioId(null);
        setMotivo("");
        setCarregandoUsuarios(true);
        usuarioService.listarUsuariosMydashSolicitacao(solicitacao.id)
            .then(res => setUsuarios(res.data))
            .catch(() => setUsuarios([]))
            .finally(() => setCarregandoUsuarios(false));
    }, [isOpen, solicitacao]);

    if (!solicitacao) return null;

    const etapaTxt = solicitacao.etapaAtual
        ? (etapaLabel(solicitacao.tipoProcesso, solicitacao.etapaAtual) || humanizarEtapa(solicitacao.etapaAtual))
        : "Encerrada";
    const responsavelAtualTxt = solicitacao.responsavelAtualNome || solicitacao.grupoResponsavelAtualNome || "-";
    const semElegiveis = !carregandoUsuarios && usuarios.length === 0;
    const podeConfirmar = !salvando && !!novoUsuarioId && !!motivo.trim() && !semElegiveis;

    function confirmar() {
        setSalvando(true);
        onConfirmar(novoUsuarioId, motivo.trim())
            .catch(() => { })
            .finally(() => setSalvando(false));
    }

    return (
        <DrawerLateral
            isOpen={isOpen}
            onClose={onFechar}
            title="Alterar responsável"
            footer={
                <div className="flex justify-end gap-2">
                    <Button variant="outline" label="Cancelar" onClick={onFechar} disabled={salvando} />
                    <Button
                        variant="blue"
                        label="Alterar responsável"
                        iconLeft="fa fa-user-check"
                        loading={salvando}
                        disabled={!podeConfirmar}
                        onClick={confirmar}
                    />
                </div>
            }
        >
            <div className="grid grid-cols-2 gap-3 text-sm">
                <Campo label="Solicitação" valor={solicitacao.numero} />
                <Campo label="Etapa" valor={etapaTxt} />
            </div>

            <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-foreground/80">Responsável atual</label>
                <p className="text-sm text-foreground">{responsavelAtualTxt}</p>
            </div>

            <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-foreground/80">
                    Novo responsável <span className="text-destructive">*</span>
                </label>
                <CustomDropdown
                    value={novoUsuarioId}
                    onChange={e => setNovoUsuarioId(e.value)}
                    options={usuarios}
                    optionValue="id"
                    optionLabel="nome"
                    placeholder={carregandoUsuarios ? "Carregando..." : "Selecione um usuário"}
                    disabled={carregandoUsuarios || semElegiveis}
                    filter
                />
                {semElegiveis && (
                    <span className="text-xs text-destructive">
                        Nenhum usuário elegível encontrado para esta etapa.
                    </span>
                )}
            </div>

            <div className="flex flex-col gap-1.5">
                <label className="text-sm font-medium text-foreground/80">
                    Motivo da alteração <span className="text-destructive">*</span>
                </label>
                <Textarea
                    id="motivo-alterar-responsavel"
                    placeholder="Informe o motivo..."
                    value={motivo}
                    onChange={e => setMotivo(e.target.value)}
                    rows={3}
                />
            </div>
        </DrawerLateral>
    );
}

function Campo({ label, valor }) {
    return (
        <div className="min-w-0">
            <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">{label}</span>
            <span className="block text-foreground font-medium truncate" title={valor || "-"}>{valor || "-"}</span>
        </div>
    );
}
